import BarandeBash from '@components/barande-bash/BarandeBash';
import ImamrezaLevelCompetition, {competitionImamrezaLoader} from '@components/competitions/ImamrezaCompetition';
import Ahd, {ahdLoader} from '@components/competitions/levels/ahd/Ahd';
import Result, {competitionResultImamrezaLoader} from '@components/competitions/levels/imamreza/Result';
import {ImamrezaServicesMode} from '@components/competitions/levels/imamreza/services/ImamrezaServicesMode';
import SharedResult, {competitionSharedImamrezaLoader} from '@components/competitions/levels/imamreza/SharedResult';
import {wordsLoader} from '@components/competitions/levels/move/Move';
import Muharram from '@components/competitions/levels/muharram-no-day/Muharram';
import Tekyehmajazi from '@components/competitions/levels/tekyehmajazi/Tekyehmajazi';
import MuharramLevelCompetition, {competitionMuharramLoader} from '@components/competitions/MuharramCompetition';
// import ShadCompetition, {competitionShadLoader} from '@components/competitions/ShadCompetition';
import TekyehmajaziLevelCompetition, {
	competitionTekyehmajaziLoader
} from '@components/competitions/TekyehmajaziCompetition';
import Channels, {channelsLoader} from '@components/network/Channels';
import NotFound from '@components/pages/NotFound';
import {DevSupport} from '@react-buddy/ide-toolbox';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
// import ResizeObserver from 'resize-observer-polyfill';
import {install, ResizeObserver} from 'resize-observer';
import {ComponentPreviews} from 'src/dev';
// import {AnalyticsProvider} from 'use-analytics';
import About from './components/app/About';
import App from './components/app/App';
import './index.css';
import './locale/i18n';
import Main from './components/app/Main';
import Privacy from './components/app/Privacy';
import Calendar from './components/calendar/Calendar';
import Callback, {callbackLoader} from './components/callback/Callback';
import Competition, {competitionLoader} from './components/competitions/Competition';
import CompetitionsCategories, {competitionsCategoriesLoader} from './components/competitions/CompetitionsCategories';
import CompetitionsList, {competitionsListLoader} from './components/competitions/CompetitionsList';
import CultureCompetition, {competitionsLoader} from './components/culture-competition/CultureCompetition';
import CultureCompetitions, {categoriesLoader} from './components/culture-competition/CultureCompetitions';
import Dynamism, {dynamismsLoader} from './components/dynamism/Dynamism';
import Dynamisms, {dynamismCategoriesLoader} from './components/dynamism/Dynamisms';
import Home from './components/home/Home';
import LikeQuran from './components/like-quran/LikeQuran';
import Channel from './components/network/Channel';
import Network from './components/network/Network';
import Parking from './components/parking';
import ParkingRoute from './components/parking/components/ParkingRoute';
import Prayer from './components/prayer/Prayer';
import PrayerCategory from './components/prayer/PrayerCategory';
import EditProfile from './components/profile/EditProfile';
import Logout, {logoutLoader} from './components/profile/Logout';
import Profile from './components/profile/Profile';
import Radio from './components/radio';
import Routing from './components/routing/Routing';
import Services from './components/services/Services';
import Settings from './components/setting/Settings';
import {useInitial} from './dev';
// import {analyticsPlugins} from './plugins/analytics';
import './fonts/fonts.css';

const ro = new ResizeObserver(() => {
	// console.log('resize observed!')
});
ro.observe(document.body);
install();
// const ro = new ResizeObserver((entries, observer) => {
// 	for (const entry of entries) {
// 		const {left, top, width, height} = entry.contentRect;
//
// 		console.log('Element:', entry.target);
// 		console.log(`Element's size: ${ width }px x ${ height }px`);
// 		console.log(`Element's paddings: ${ top }px ; ${ left }px`);
// 	}
// });
// ro.observe(document.body);

// if (!window.ResizeObserver)
// 	window.ResizeObserver = ResizeObserver;
// const ErrorBoundaryLayout = () => (
// 	<ErrorBoundary FallbackComponent={GlobalError}>
//  		<Outlet/>
//  	</ErrorBoundary>
// )
const router = createBrowserRouter([
	{
		path: '/',
		element: <App/>,
		children: [
			{
				index: true,
				element: <Main><Home/></Main>
			},
			{
				path: '/services',
				element: <Main><Services/></Main>
			},
			{
				path: '/network',
				element: <Main><Network/></Main>
			},
			{
				path: '/network/:channelId',
				element: <Channel/>
			},
			{
				path: '/channels',
				element: <Main><Channels/></Main>,
				loader: channelsLoader
			},
			{
				path: '/calendar',
				element: <Calendar/>
			},
			{
				path: '/profile',
				element: <Profile/>
			},
			{
				path: '/profile/edit',
				element: <EditProfile/>
			},
			{
				path: '/competitions',
				element: <CompetitionsCategories/>,
				loader: competitionsCategoriesLoader
			},
			{
				path: '/competitions/:categoryId',
				element: <CompetitionsList/>,
				loader: competitionsListLoader
			},
			// {
			// 	path: '/competition/harekat',
			// 	element: <ShadCompetition/>,
			// 	loader: competitionShadLoader
			// },
			{
				path: '/competition/tekyehmajazi',
				element: <TekyehmajaziLevelCompetition/>,
				loader: competitionTekyehmajaziLoader
			},
			{
				path: '/competition/muharram',
				element: <MuharramLevelCompetition/>,
				loader: competitionMuharramLoader
			},
			{
				path: '/competition/imamreza/*',
				element: <ImamrezaLevelCompetition/>,
				loader: competitionImamrezaLoader
			},
			{
				path: '/competition/imamreza-result/:ref',
				element: <SharedResult/>,
				loader: competitionSharedImamrezaLoader
			},
			{
				path: '/competition/result/:ref',
				element: <Result/>,
				loader: competitionResultImamrezaLoader
			},
			{
				path: '/competition/imamreza-services/:type/:mode',
				element: <ImamrezaServicesMode/>
				// loader: competitionSharedImamrezaLoader
			},
			{
				path: '/competition/:competitionId',
				element: <Competition/>,
				loader: competitionLoader
			},
			// {
			// 	path: '/imamreza',
			// 	element: <ImamReza/>,
			// 	loader: wordsLoader
			// },
			{
				path: '/tekyehmajazi',
				element: <Tekyehmajazi/>,
				loader: wordsLoader
			},
			{
				path: '/muharram',
				element: <Muharram/>,
				loader: wordsLoader
			},
			{
				path: '/ahd',
				element: <Ahd/>,
				loader: ahdLoader
			},
			/*	{
			 path: '/iran',
			 element: <Iran/>,
			 loader: iranCountLoader
			 },*/
			// {
			// 	path: '/move/:competitionId/',
			// 	element: <Move/>,
			// 	loader: wordsLoader
			// },
			// {
			// 	path: '/questions/:competitionId/',
			// 	element: <Questions/>,
			// 	loader: questionsLoader
			// },
			// {
			// 	path: '/questions/:competitionId/:state',
			// 	element: <Questions/>,
			// 	loader: questionsLoader
			// },
			{
				path: '/competition-old',
				element: <CultureCompetitions/>,
				loader: categoriesLoader
			},
			{
				path: '/competition-old/:categoryId',
				element: <CultureCompetition/>,
				loader: competitionsLoader
			},
			{
				path: '/dynamisms',
				element: <Dynamisms/>,
				loader: dynamismCategoriesLoader
			},
			{
				path: '/dynamism/:categoryId',
				element: <Dynamism/>,
				loader: dynamismsLoader
			},
			{
				path: '/about',
				element: <About/>
			},
			{
				path: '/privacy',
				element: <Privacy/>
			},
			{
				path: '/routing',
				element: <Routing/>
			},
			{
				path: '/barandebash',
				element: <BarandeBash/>
			},
			{
				path: '/logout',
				element: <Logout/>,
				loader: logoutLoader
			},
			{
				path: '/prayer',
				element: <PrayerCategory/>
			},
			{
				path: '/prayer/:id',
				element: <Prayer/>
			},
			{
				path: '/prayer/:id/:subId',
				element: <Prayer/>
			},
			{
				path: '/prayer/:id/:subId/:endId',
				element: <Prayer/>
			},
			{
				path: '/settings',
				element: <Settings/>
			},
			{
				path: '/quran',
				element: <LikeQuran/>
			},
			{
				path: '/radio',
				element: <Radio/>
			},
			{
				path: '/parking',
				element: <Parking/>
			},
			{
				path: '/parking/route/:places/:start/:stop',
				element: <ParkingRoute/>
			},
			{
				path: '/callback',
				element: <Callback/>,
				loader: callbackLoader
			},
			{
				path: '*',
				element: <NotFound/>
			}
		]
	}
]);

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	//TODO read StrictMode function
	// <React.StrictMode>
	//todo disable AnalyticsProvider for test performance
	// <AnalyticsProvider instance={analyticsPlugins}>
		<DevSupport ComponentPreviews={ComponentPreviews}
		            useInitialHook={useInitial}
		>
			<RouterProvider router={router}/>
		</DevSupport>
	// </AnalyticsProvider>
	// </React.StrictMode>
);
